import "./index.less";
import { useLocation, useNavigate } from "react-router-dom";
import DropdownMenu from './menuPop'
import AccountConnect from './AccountConnect'
import WalletButton from "./WalletButton"
// import { LanguageSwitcher } from './LanguageSwitcher';
import { useI18n } from '../contexts/I18nContext';
import { useWeb3 } from './js/useWeb3'
import { useState,useEffect } from "react";
import { useDispatch,useSelector } from 'react-redux'
import { setNowNetwork  } from '../store/networkReducer'
import MobilePop from './mobilePop'
import { useTranslation } from "react-i18next";



const Header = () => {
  // const { t, translating, language } = useI18n();
  const { t, i18n }: { t: any,i18n:any } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [popTitle, setpopTitle] = useState('JuChain Mainnet');
  const [showMobilePop, setshowMobilePop] = useState(false);
  const navList = [
    { name: t('HT1'), path: "/" },
    // { name: "Issued tokens", path: "/my-token" },
    { name: t('HT2'), path: "" },
  ];
  const dispatch = useDispatch();

  useEffect(() => {
    const chanIndex = localStorage.getItem("chanIndex");
    if (chanIndex !== null) {
      setpopTitle(chanIndex === "0" ? "JuChain Mainnet" : "JuChain Testnet");
    }
  }, []); // 只在组件加载时执行

  const { switchIndex } = useWeb3();

  const selectChan = (title: any,index:any) => {
    console.log(title,index,'222');
    setpopTitle(title)
    switchIndex(index)
    dispatch(setNowNetwork(title))
  }

  return (
    <div className="ju-header">
      <div className="header-logo" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection:'row'}}>
        <img src="/icon/menuIcon.png" alt="" style={{width:20,height:28,cursor: 'pointer',marginRight:'15px'}} onClick={() => {setshowMobilePop(true)}} />
        <img src="/icon/logo.png" alt="JuChain" style={{width:99,height:28,cursor: 'pointer'}} onClick={() => {
                window.open('https://www.juchain.org')
            }} />
        {/* <span style={{ fontSize:24,color:'#fff',fontWeight:'bolder',marginLeft:10}}>JuChain</span> */}
      </div>
      <div className="header-nav">
        {navList.map((item) => (
          <span
            className={
              "header-nav-item" +
              (pathname === item.path ? " header-nav-item-active" : "")
            }
            key={item.name}
            onClick={() => {
              if (item.name == t('HT2')) {
                // window.open('http://38.165.46.98:9091')
                window.location.href = 'http://tra.juchain.link/batch'
                // window.open('http://tools.juchain.org/batch')
              } else {
                // 使用react的路由跳转
              navigate(item.path);
              }
            }}
            data-translate
          >
            {item.name}
          </span>
        ))}
      </div>
      <div style={{marginLeft:'auto'}}>
      <DropdownMenu onChildMenuAction={(lang) => i18n.changeLanguage(lang)} title='' textList={['English','简体中文']}></DropdownMenu>
      </div>
      <div className="header-right">
        <DropdownMenu onChildMenuAction={selectChan} title={popTitle}></DropdownMenu>
      </div>  
        <WalletButton/>
      {showMobilePop && <MobilePop title={popTitle} onClose={()=>setshowMobilePop(false)} onChildMenuAction={(title,index,type)=>{
        if(type == 'JuChan'){
          selectChan(title,index)
          return
        }
        if(index == 1) window.location.href = window.location.href = 'http://tra.juchain.link/batch'
      }}></MobilePop>}
      {/* <AccountConnect/> */}
      {/* {!isConnect ? (
        <Button
          rootClassName="connect-btn"
          type="primary"
          onClick={() => {
            setIsConnect(true);
          }}
        >
          Connect
        </Button>
      ) : (
        <span className="address-wrapper" onClick={() => setIsConnect(false)}>
          <img src="/icon/avatar.svg" alt="" />
          0x96d8...54b6{" "}
        </span>
      )} */}
    </div>
  );
};

export default Header;
